<template>
  <div class="bannerskip-container">
    <el-select
      ref="select"
      v-model="value"
      placeholder="请选择跳转目标，可输入关键字搜索"
      filterable
      clearable
      prefix-icon="el-icon-search"
      :filter-method="searchCourse"
      :disabled="disabled"
      :style="tcfstyle"
      @clear="clearSelect"
    >
      <el-option :value="value" :label="changeLabel" style="height: auto;padding: 0;">
        <el-table
          :data="tableData"
          :show-header="false"
          style="width: 100%"
          @row-click="openDetails">
          <el-table-column
            label="活动名称"
            min-width="500">
            <template slot-scope="scope">
              <span style="margin-left: 10px;font-weight: normal">{{ scope.row.name }}</span>
            </template>
          </el-table-column>
        </el-table>
      </el-option>
      <el-pagination
        v-if="total>0"
        style="padding:10px"
        background
        :current-page="currentPage"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @current-change="handleCurrentChange"
      />
    </el-select>
  </div>
</template>

<script>
import { getCaseList, getCaseInfo } from '@/api/community'
import { getUser } from '@/utils/auth'

export default {
  name: 'selectcaselist',
  props: {
    bid: {
      type: Number
    },
    olddataid: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tcfstyle: {
      type: String,
      default: 'width: 100%'
    }
  },
  data() {
    return {
      loading: false,
      tableData: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
      filterText: '',
      value: '',
      changeLabel: ''
    }
  },
  computed: {
    user: getUser
  },
  created() {
    this.getData()
    if (this.olddataid !== null && this.olddataid !== '' && this.olddataid !== undefined && this.olddataid !== 0) {
      if (this.selecttype === 3) {
        this.getOfflineInfo()
      } else if (this.selecttype === 4) {
        this.getLiveInfo()
      } else if (this.selecttype === 5) {
        this.getCaseInfo()
      } else if (this.selecttype === 6) {
        this.getStrategyInfo()
      } else if (this.selecttype === 7) {
        this.getShowHomeInfo()
      }
    }
  },
  methods: {
    getCase() {
      const data = {
        page: this.currentPage,
        limit: this.pageSize,
        search: this.filterText,
        delid: this.user.delid,
        brand: this.bid
      }
      getCaseList(data).then(response => {
        this.loading = false
        this.total = response.total
        const cases = []
        response.data.forEach(row => {
          cases.push({
            name: row.title,
            dataid: row.cid
          })
        })
        this.tableData = cases
      }).catch(() => {
        this.loading = false
      })
    },
    getCaseInfo() {
      getCaseInfo({ cid: this.olddataid }).then(response => {
        this.value = response.data.cid
        this.changeLabel = response.data.title
        this.$emit('input', { dataid: response.data.cid, name: response.data.title })
      })
    },
    getData() {
      this.loading = true
      this.getCase()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getData()
    },
    clearSelect() {
      this.filterText = ''
      this.value = ''
      this.changeLabel = ''
      this.$emit('input', null)
    },
    searchCourse(val) {
      this.filterText = val
      this.getData()
    },
    openDetails(data) {
      this.value = data.dataid
      this.changeLabel = data.name
      this.$emit('input', { dataid: data.dataid, name: data.name })
      // this.$emit('setCourse', data)
      this.$refs.select.blur()
    }
  }
}
</script>

<style lang="scss" scoped>
  .bannerskip-container{
    .el-table::before{
      height: 0!important;
    }
    .el-pagination{
      margin-top: 20px;
    }
  }
</style>
